export const EVENT_STATUS = {
  SCHEDULED: "SCHEDULED",
  OPEN: "OPEN",
  PAUSED: "PAUSED",
  CLOSED: "CLOSED",
  DRAWN: "DRAWN",
  ENDED: "ENDED",
};

export const EVENT_TYPE = {
  LAUNCHPAD: "LAUNCHPAD",
  LOTTERY: "LOTTERY",
};

export const SUBMIT_RESULT = {
  WIN: "WIN",
  WRONG: "WRONG",
  CLOSED: "CLOSED",
  ALREADY_WINNER: "ALREADY_WINNER",
  COOLDOWN: "COOLDOWN",
};

export const LOTTERY_USER_STATUS = {
  NOT_SUBSCRIBED: "NOT_SUBSCRIBED",
  SUBSCRIBED: "SUBSCRIBED",
  WON: "WON",
  LOST: "LOST",
};

export const WINNER_INFO_STATUS = {
  PENDING_SUBMISSION: "PENDING_SUBMISSION",
  SUBMITTED: "SUBMITTED",
  EXPIRED: "EXPIRED",
};

export const DELIVERY_STATUS = {
  PENDING: "PENDING",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
};

export const COOLDOWN_SECONDS = 30;

export const INFO_DEADLINE_DAYS = 3;

export const MAX_MODIFICATIONS = 3;

export const POLLING_INTERVAL = {
  STATUS: 15000,
  STATUS_SLOW: 60000,
  STATUS_FAST: 1000,
  COUNTDOWN: 1000,
};

export const NEWYEAR_ROUTES = {
  LAUNCHPAD: "/newyear/launchpad",
  LOTTERY: "/newyear/lottery",
  WINNER_INFO: "/newyear/winner",
};
